import { IGlobalState } from '../../../Root/store/appReducer'

export const getCompanyAdminInfo = (state: IGlobalState) => state.companyAdmin?.companyInfo
export const getCompanyAdminLoading = (state: IGlobalState) => state.companyAdmin?.loading
export const getCompanyAdminSaving = (state: IGlobalState) => state.companyAdmin?.saving
export const getCompanyAdminLastUpdated = (state: IGlobalState) => state.companyAdmin?.lastUpdated
export const getCompanyAdminSelectedCompanyId = (state: IGlobalState) => state.companyAdmin?.selectedCompanyId
